import { CombinedState, PayloadAction } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { donationPageSlice, DonationPageStateType } from 'src/pages/DonationSetup/containers/slice';
import { SignInOutInitialStateType, signInOutSlice } from 'src/pages/Account/Profile/Signin/store/slice';
import { anyRequestSlice, AnyRequestSliceStateType } from 'src/store/anyRequest/slice';
import { commonSlice, InitialCommonStateType } from 'src/store/commonPart/slice';
import { featureFlagsSlice, FeatureFlagsStateType } from 'src/store/featureFlags/slice';
import { GLOBAL_CLEAR_STORE_TYPE } from 'src/store/global';
import { overlaySlice, OverlaySliceStateType } from 'src/store/overlay/slice';
import { currentUserSlice, CurrentUserStateType } from 'src/store/user/slice';
import { SafeAnyType } from 'src/utils/safeAny';
import { plusSubscriptionSlice, PlusSubscriptionSliceStateType } from 'src/store/plusSubscription/slice';
import { accountOrganizerSlice, AccountOrganizerStateType } from 'src/store/organizer/slice';

const appReducer = combineReducers({
  [signInOutSlice.name]: signInOutSlice.reducer,
  [commonSlice.name]: commonSlice.reducer,
  [donationPageSlice.name]: donationPageSlice.reducer,
  [currentUserSlice.name]: currentUserSlice.reducer,
  [anyRequestSlice.name]: anyRequestSlice.reducer,
  [overlaySlice.name]: overlaySlice.reducer,
  [featureFlagsSlice.name]: featureFlagsSlice.reducer,
  [plusSubscriptionSlice.name]: plusSubscriptionSlice.reducer,
  [accountOrganizerSlice.name]: accountOrganizerSlice.reducer,
});

export const rootReducers = (
  state: SafeAnyType,
  action: PayloadAction
): CombinedState<{
  // how to express types more efficiently ?
  [signInOutSlice.name]: SignInOutInitialStateType;
  [commonSlice.name]: InitialCommonStateType;
  [donationPageSlice.name]: DonationPageStateType;
  [currentUserSlice.name]: CurrentUserStateType;
  [anyRequestSlice.name]: AnyRequestSliceStateType;
  [overlaySlice.name]: OverlaySliceStateType;
  [featureFlagsSlice.name]: FeatureFlagsStateType;
  [plusSubscriptionSlice.name]: PlusSubscriptionSliceStateType;
  [accountOrganizerSlice.name]: AccountOrganizerStateType;
}> => appReducer(action.type === GLOBAL_CLEAR_STORE_TYPE ? undefined : state, action);
